import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import cs from 'vuetify/src/locale/cs';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { cs },
    current: 'cs',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#E56300',
        primaryDark: '#D95E00',
        secondary: '#0c9800',
        error: '#FF5252',
        success: '#10CC72',
        avatar: '#B686E2',
        neutral: '#d1d1d1',
        grey: '#666666',
        warning: '#FB8C00',
        greymed: '#8B93B8',
        greylight: '#F2F4FF',
        greytext: '#CACACA',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
